import React from 'react';
import LocationIcon from '../../icons/locationIcon';
import COLORS from '../../../../../common/colors';

const CardLocation = ({
	location, className, gap, size
}) => (
	<span className={className} style={{ textTransform: 'capitalize' }}>
		{typeof location === 'undefined' || location === null || location === ''? null : <LocationIcon
			color={COLORS.givePrimary}
			size={size || '0.875rem'}
			style={{
				display: 'inline-block',
				lineHeight: '0',
				marginRight: gap || '3px',
				width: size || '0.875rem',
			}}
		/>}
		{location}
	</span>
);

export default CardLocation;
